// extracted by mini-css-extract-plugin
module.exports = {"main":"FilterActivity_main__23PmF"};